<template>
  <v-dialog
    max-width="500"
    :value="orderError.error"
    @click:outside="$store.commit('orders/CLOSE_ORDER_ERROR_DIALOG')"
  >
    <v-card class="py-10 px-7">
      <CloseDialogButton
        :close="() => $store.commit('orders/CLOSE_ORDER_ERROR_DIALOG')"
      />
      <div class="align-center d-flex flex-column">
        <v-icon class="mb-8 sticker-alert-icon-font-size" color="primary"
          >mdi-sticker-alert-outline</v-icon
        >
        <div class="mb-12 text-center">
          {{ orderError.message }}
        </div>
        <v-btn
          color="primary"
          height="48"
          width="180"
          rounded
          @click.stop="$store.commit('orders/CLOSE_ORDER_ERROR_DIALOG')"
        >
          <div class="font-size-md">ok</div>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "ErrorDialog",
  components: { CloseDialogButton },
  computed: {
    ...mapState({
      orderError: (state) => state.orders.dialog.orderError,
    }),
  },
};
</script>

<style scoped>
.circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.clock-image {
  background: var(--v-primary-base) url(~@/assets/checkout/ic-clock.svg)
    no-repeat center;
  background-size: 72px 72px;
}
.sticker-alert-icon-font-size {
  font-size: 100px;
}
</style>
